import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';

const ProtectedRoute = ({ children, requiredRole, requiredPage }) => {
  const { user, token, loading, hasRole, canAccess } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div className="loading-container">
        <div className="spinner"></div>
        <p>Loading...</p>
      </div>
    );
  }

  // Not authenticated
  if (!token || !user) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  // Check role requirement
  if (requiredRole && !hasRole(requiredRole)) {
    return (
      <div className="access-denied">
        <h2>🔒 Access Denied</h2>
        <p>You don't have permission to view this page.</p>
        <p>Required role: <strong>{requiredRole}</strong></p>
      </div>
    );
  }

  // Check page access requirement
  if (requiredPage && !canAccess(requiredPage)) {
    return (
      <div className="access-denied">
        <h2>🔒 Access Denied</h2>
        <p>You don't have access to this page.</p>
        <p>Contact your administrator for access.</p>
      </div>
    );
  }

  return children;
};

export default ProtectedRoute;
